module.exports = __webpack_public_path__ + "img/arepholding.e3b5cbb8.jpg";